import {ListItem} from '@github-ui/list-view'
import {type Dispatch, type SetStateAction, useEffect} from 'react'
import {graphql, useFragment} from 'react-relay'

import type {IssueTypeIndicator$key} from './__generated__/IssueTypeIndicator.graphql'

const issueTypeQuery = graphql`
  fragment IssueTypeIndicator on Issue {
    number
    issueType {
      id
      name
      isEnabled
    }
    viewerCanSeeIssueType
  }
`
type Props = {
  dataKey: IssueTypeIndicator$key
  // TODO: clean up once https://github.com/github/collaboration-workflows-flex/issues/256 is merged
  onRender?: Dispatch<SetStateAction<boolean>>
  getIssueTypeHref: (login: string) => string
}

export const IssueTypeIndicator = ({dataKey, onRender, getIssueTypeHref}: Props) => {
  const {issueType, number, viewerCanSeeIssueType} = useFragment(issueTypeQuery, dataKey)

  const shouldNotRender = !viewerCanSeeIssueType || !issueType?.id || !issueType?.name || !issueType?.isEnabled

  // Temp solution, TODO: clean up once https://github.com/github/collaboration-workflows-flex/issues/256 is merged,
  // see https://github.slack.com/archives/C05HD5GU6CA/p1700480160214479
  useEffect(() => {
    if (!shouldNotRender && onRender) {
      onRender?.(true)
    }
  }, [onRender, shouldNotRender])

  if (shouldNotRender) {
    return null
  }

  return (
    <ListItem.LeadingBadge
      data-testid={`${number}-issue-type-indicator-${issueType.name}`}
      key={issueType.id}
      size={'small'}
      variant={'secondary'}
      title={issueType.name}
      href={getIssueTypeHref(issueType.name)}
      containerSx={{
        '> span': {
          backgroundColor: 'canvas.inset',
          verticalAlign: '1px',
          borderColor: 'border.muted',
          pb: '1px',
        },
      }}
    />
  )
}

try{ IssueTypeIndicator.displayName ||= 'IssueTypeIndicator' } catch {}